import React from 'react';
import PropTypes from 'prop-types';
import Tile from '../../assets/tile.svg';
import List from '../../assets/list.svg';

const ViewSelector = ({ selectView, selectedView }) => (
  <div className="react-cinema-filter-visibility-icons">
    <Tile
      className={`react-cinema-filter-visibility-tile${selectedView === 'tile' ? ' active' : ''}`}
      onClick={() => { selectView('tile'); }}
    />
    <List
      className={`react-cinema-filter-visibility-list${selectedView === 'list' ? ' active' : ''}`}
      onClick={() => { selectView('list'); }}
    />
  </div>
);

ViewSelector.propTypes = {
  selectView: PropTypes.func.isRequired,
  selectedView: PropTypes.string.isRequired,
};

export default ViewSelector;
